import React from "react"
import CommitButtonWithClickState from "../CommitButtonWithClickState/CommitButtonWithClickState"
import TransparentButton from "../TransparentButton/TransparentButton"
import CommitInput from "../CommitInput/CommitInput"
import SkeletonWrapper from "../SkeletonWrapper/SkeletonWrapper"

export default class RoadmapperEditInputContainer extends React.Component {
  constructor(props) {
    super(props)
    // Handle value - it might be an object with name property from API, or a string
    // Also ensure we have the value name even if we only have value_id
    const timeEvent = { ...this.props.timeEvent }
    if (timeEvent.value && typeof timeEvent.value === 'object' && timeEvent.value.name) {
      timeEvent.value = timeEvent.value.name
    } else if (!timeEvent.value && timeEvent.value_id && this.props.values && Array.isArray(this.props.values)) {
      // If we have value_id but no value name, look it up from props.values
      const matchingValue = this.props.values.find((val) => val.id === timeEvent.value_id)
      if (matchingValue) {
        timeEvent.value = matchingValue.name || matchingValue.value || ""
      }
    }
    this.state = {
      event: timeEvent
    }
    this.deleteTimeEvent = this.deleteTimeEvent.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onValueChange = this.onValueChange.bind(this)
    this.onDurationChange = this.onDurationChange.bind(this)
    this.onTitleChange = this.onTitleChange.bind(this)
  }

  deleteTimeEvent = () => {
    this.props.deleteTimeEvent()
  }

  onChange = (e) => {
    const event = {
      ...this.state.event,
      [e.target.name]: e.target.value
    }
    this.props.updateEditEvent({ ...event })
    this.setState({ event })
  }

  onValueChange = (e) => {
    const event = {
      ...this.state.event,
      value: e.target.value
    }
    this.props.updateEditEvent({ ...event })
    this.setState({ event })
  }

  onDurationChange = (e) => {
    // Extract duration from "15 minutes" format
    const durationString = e.target.value || ""
    const duration = parseInt(durationString.replace(/\s*minutes?/i, "")) || 15
    const event = {
      ...this.state.event,
      duration: duration
    }
    this.props.updateEditEvent({ ...event })
    this.setState({ event })
  }

  onTitleChange = (e) => {
    if (e.target.value.length < 255) {
      const event = {
        ...this.state.event,
        title: e.target.value
      }
      this.props.updateEditEvent({ ...event })
      this.setState({ event })
    }
  }

  componentDidMount() {
    // Normalize timeEvent value before passing to parent
    const normalizedTimeEvent = { ...this.props.timeEvent }
    if (normalizedTimeEvent.value && typeof normalizedTimeEvent.value === 'object' && normalizedTimeEvent.value.name) {
      normalizedTimeEvent.value = normalizedTimeEvent.value.name
    } else if (!normalizedTimeEvent.value && normalizedTimeEvent.value_id && this.props.values && Array.isArray(this.props.values)) {
      // If we have value_id but no value name, look it up from props.values
      const matchingValue = this.props.values.find((val) => val.id === normalizedTimeEvent.value_id)
      if (matchingValue) {
        normalizedTimeEvent.value = matchingValue.name || matchingValue.value || ""
      }
    }
    this.props.updateEditEvent(normalizedTimeEvent)
    
    const editedEvent = document.getElementById("roadmapperEditedEvent")
    if (editedEvent) {
      editedEvent.scrollIntoView({ behavior: "smooth" })
    }
  }
  
  componentDidUpdate(prevProps) {
    // If values prop changes or timeEvent changes, update the value name if needed
    if (prevProps.values !== this.props.values || prevProps.timeEvent !== this.props.timeEvent) {
      const timeEvent = { ...this.props.timeEvent }
      
      // If we have value_id but the current value doesn't match, update it
      if (timeEvent.value_id && this.props.values && Array.isArray(this.props.values)) {
        const matchingValue = this.props.values.find((val) => val.id === timeEvent.value_id)
        const expectedValueName = matchingValue ? (matchingValue.name || matchingValue.value || "") : ""
        
        // Update if:
        // 1. We have a matching value and current value doesn't match
        // 2. We don't have a value name but we have value_id
        if (matchingValue && this.state.event.value !== expectedValueName) {
          const updatedEvent = {
            ...this.state.event,
            value: expectedValueName
          }
          this.setState({ event: updatedEvent })
          this.props.updateEditEvent(updatedEvent)
        } else if (!this.state.event.value && timeEvent.value_id && !matchingValue) {
          // If value_id exists but no matching value found, set to empty (will show "Non-Value")
          const updatedEvent = {
            ...this.state.event,
            value: ""
          }
          this.setState({ event: updatedEvent })
        }
      } else if (timeEvent.value && this.state.event.value !== timeEvent.value) {
        // If timeEvent has a value property that changed, update state
        const updatedEvent = {
          ...this.state.event,
          value: timeEvent.value
        }
        this.setState({ event: updatedEvent })
      }
    }
  }

  getValueOptions = () => {
    if (this.props.values && Array.isArray(this.props.values) && this.props.values.length > 0) {
      return this.props.values.map((value) => {
        const optionValue = value.name || value.value || ""
        return {
          value: optionValue
        }
      })
    } else {
      return [{ value: "Non-Value" }]
    }
  }

  render() {
    return (
      <div style={styles.container} id="roadmapperEditedEvent">
        {this.props.timeEvent.id === 0 ? (
          <SkeletonWrapper />
        ) : (
          <>
            <CommitInput
              inputType="text"
              placeHolder="Activity"
              handleChange={this.onTitleChange}
              value={this.state.event.title}
            />
            <div style={styles.block}>
              <CommitInput
                style={styles.durationSegment}
                name="duration"
                title="Time Allowed"
                inputType="select"
                value={this.state.event.duration ? `${this.state.event.duration} minutes` : "15 minutes"}
                options={[
                  { value: `15 minutes` },
                  { value: `30 minutes` },
                  { value: `45 minutes` },
                  { value: `60 minutes` },
                  { value: `90 minutes` },
                  { value: `120 minutes` }
                ]}
                handleChange={this.onDurationChange}
              />
              <CommitInput
                style={styles.valueSegment}
                title="Value"
                inputType="select"
                name="value"
                value={this.state.event.value || ""}
                options={this.getValueOptions()}
                handleChange={this.onValueChange}
              />
            </div>
            <div style={styles.buttonContainer}>
              <div style={styles.deleteButtonContainer}>
                <TransparentButton
                  // style={styles.deleteButton}
                  onClick={this.deleteTimeEvent}
                >
                  Delete
                </TransparentButton>
              </div>
              <CommitButtonWithClickState
                type="red"
                clickHandler={this.props.clickHandler}
                id="FinsihEditingEvent"
                style={styles.saveButton}
              >
                {" "}
                Done{" "}
              </CommitButtonWithClickState>
            </div>
          </>
        )}
      </div>
    )
  }
}

const styles = {
  container: {
    display: "inline-block",
    width: "100%",
    padding: "30px 18px 23px 25px",
    boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.1)",
    borderRadius: "3px"
  },
  title: {
    height: "18px",
    fontFamily: "Lato-Regular",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "13px",
    lineHeight: "17px",
    color: "#292E4C",
    margin: "0"
  },
  titleInput: {
    width: "100%",
    margin: "auto"
  },
  block: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap"
  },
  buttonContainer: {
    display: "flex",
    float: "right"
  },
  // deleteButton: {
  //   width: "62px",
  // },
  deleteButtonContainer: {
    width: "62px",
    margin: "auto",
    marginRight: "10px",
    marginLeft: "10px",
    height: "fit-content"
  },
  saveButton: {
    width: "133px"
  },
  valueSegment: {
    width: "calc(100% - 175px)",
    minWidth: "160px",
    maxWidth: "340px",
    textAlign: "left",
    marginLeft: "5px"
  },
  durationSegment: {
    width: "165px",
    textAlign: "left",
    marginRight: "auto",
    fontSize: "13px"
  }
}
